<template>
  <div class="d-flex justify-space-between">
    <PersonCardHeader
      class="flex-grow-1"
      :title="title"
      :firstName="person.first_name"
      :lastName="person.last_name"
      :lastUpdate="person.meta.updated_at"
      :type="person.civility"
      :editingMode="editingMode"
    />
    <v-btn
      v-ripple="false"
      class="btn-wesave no-padding"
      text
      @click="$emit('close')"
    >
      <img
        alt=""
        :src="'./assets/icons/close.svg'"
        class="picto"
      />
    </v-btn>
  </div>
</template>

<script>
  import PersonCardHeader from '@/components/ui/PersonCardHeader/PersonCardHeader'

  export default {
    components: {
      PersonCardHeader,
    },
    props: {
      person: {
        type: Object,
        required: true,
      },
      editingMode: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        default: '',
      },
    },
  }
</script>
